"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const ValidationError_1 = __importDefault(require("./ValidationError"));
class StreamMessageError extends ValidationError_1.default {
    constructor(msg, streamMessage, code) {
        super(msg, code);
        this.streamMessage = streamMessage;
    }
}
exports.default = StreamMessageError;
//# sourceMappingURL=StreamMessageError.js.map